function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import MosaicImageItem from "./MosaicImageItem/index.js";
import splitImagesIntoRows from "../../helper/splitImagesIntoRows.js";
import useWindowSize from "../../hooks/useWindowSize.js";
import styles from "./styles.css";
export default function MosaicComponent(_ref) {
  var _ref$images = _ref.images,
    images = _ref$images === void 0 ? [] : _ref$images,
    imageGenerationDescription = _ref.imageGenerationDescription,
    maxSelected = _ref.maxSelected,
    handleSelectOption = _ref.handleSelectOption,
    isModalOpen = _ref.isModalOpen;
  var _useWindowSize = useWindowSize(),
    width = _useWindowSize.width;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSticky = _useState2[0],
    setIsSticky = _useState2[1];
  var stickyRef = useRef(null);
  var getColumns = function getColumns() {
    if (width <= 480) {
      return 2;
    }
    if (width <= 768) {
      return 3;
    }
    return 4;
  };
  var splittedImages = splitImagesIntoRows(images, getColumns());
  useEffect(function () {
    var handleScroll = function handleScroll() {
      if (stickyRef.current) {
        var topPosition = stickyRef.current.getBoundingClientRect().top;
        var isStickyNow = topPosition <= 10;
        setIsSticky(isStickyNow);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles['mosaic-content'])
  }, /*#__PURE__*/React.createElement("p", {
    ref: stickyRef,
    style: isModalOpen ? {
      zIndex: 0
    } : {},
    className: "".concat(isSticky && !isModalOpen ? styles['is-sticky'] : '', " ").concat(styles['mosaic-content--paragraph'])
  }, imageGenerationDescription), /*#__PURE__*/React.createElement("div", {
    className: styles['mosaic-grid']
  }, _mapInstanceProperty(splittedImages).call(splittedImages, function (row, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: styles['grid-column'],
      "data-testid": "mosaic-grid-column"
    }, _mapInstanceProperty(row).call(row, function (option) {
      var _option$selected;
      return /*#__PURE__*/React.createElement(MosaicImageItem, {
        key: option.imageId,
        option: option,
        handleSelectOption: handleSelectOption,
        isSelected: (_option$selected = option.selected) !== null && _option$selected !== void 0 ? _option$selected : false,
        maxImagesSelected: maxSelected
      });
    }));
  })));
}
process.env.NODE_ENV !== "production" ? MosaicComponent.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    imageId: PropTypes.string,
    selected: PropTypes.bool
  })).isRequired,
  imageGenerationDescription: PropTypes.string.isRequired,
  handleSelectOption: PropTypes.func.isRequired,
  maxSelected: PropTypes.bool.isRequired,
  isModalOpen: PropTypes.bool.isRequired
} : void 0;